import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

// Skeleton Loading Component
export const ProjectCardSkeleton: React.FC = () => {
  return (
    <Card className="animate-pulse">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-2 flex-1">
            <div className="flex items-center gap-2">
              <div className="h-5 w-16 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
              <div className="h-5 w-16 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
            </div>
            <div className="h-6 w-3/4 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
            <div className="h-4 w-1/2 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
          </div>
          <div className="h-6 w-20 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="h-10 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
        <div className="space-y-2">
          <div className="h-4 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
          <div className="h-4 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
        </div>
        <div className="h-8 bg-neutral-300 dark:bg-neutral-700 rounded"></div>
      </CardContent>
    </Card>
  );
};

export const SkeletonGrid: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <ProjectCardSkeleton key={index} />
      ))}
    </div>
  );
};
